import React, { useRef, useEffect } from 'react';

const SectionWrapper = ({ 
  id, 
  children, 
  gradient = 'from-dark-900 to-dark-800',
  overlay = 'bg-[radial-gradient(circle_at_30%_40%,rgba(46,204,113,0.07),transparent_70%)]',
  className = '',
  scrollMargin = false
}) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('opacity-100');
          entry.target.classList.remove('opacity-0', 'translate-y-10');
          // Rastrear scroll para o Meta Pixel
          if (window.fbq && id) {
            window.fbq('trackCustom', 'ScrollSection', { section: id });
          }
        }
      },
      { threshold: 0.1 }
    );

    const currentRef = sectionRef.current;
    
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);
  
  return (
    <section 
      id={id} 
      className={`relative py-10 bg-gradient-to-b ${gradient} bg-dark-pattern bg-cover bg-fixed overflow-visible ${scrollMargin ? 'scroll-mt-20' : ''} ${className}`}
    >
      {/* Noise texture overlay */}
      <div className="absolute inset-0 opacity-10 bg-noise pointer-events-none"></div>
      
      {/* Decorative gradient overlay */}
      <div className={`absolute inset-0 ${overlay} pointer-events-none`}></div>
      
      <div 
        ref={sectionRef}
        className="container mx-auto px-4 relative z-10 opacity-0 translate-y-10 transition-all duration-700"
      >
        {children}
      </div>
    </section>
  );
};

export default SectionWrapper; 